import React, { Component } from 'react'
import ContentEditable from 'react-contenteditable'
import EmojiPicker from 'emojione-picker'
import 'emojione-picker/css/picker.css'
import '../../../node_modules/emojione/assets/css/emojione.css'
const enhanceWithClickOutside = require('react-click-outside')
import ReactHTMLConverter from 'react-html-converter'
import Scroll from 'react-scroll'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import UPDATE_MESSAGE from '../../graphql/Chat/UpdateMessage.graphql'

let scroll = Scroll.animateScroll

const converter = new ReactHTMLConverter()
converter.registerComponent('test', Conversation)

class Conversation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: [],
      file: '',
      imagePreviewUrl: '',
      text: '',
      showEmojis: false,
      html: ''
    }
  }

  componentDidMount() {
    scroll.scrollTo(99999, {
      containerId: 'message-block'
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      html: nextProps.messageText,
      files: []
    })
  }

  toggle = () => {
    if (this.state.showEmojis) {
      this.setState({ showEmojis: !this.state.showEmojis })
    }
  }
  handleClickOutside = () => {
    this.toggle()
  }

  logEmoji(emoji) {
    let text = this.state.html.replace(`<div><br></div>`, '<div></div>')
    if (text.slice(-6) === '</div>') {
      text = text.slice(0, text.length - 6)
      text = text.replace(`<div><br></div>`, '<div></div>')
    }
    let newHTML = (text += `<img class='emojione-smile-img'
        src='https://cdn.jsdelivr.net/emojione/assets/3.0/png/32/${emoji.unicode}.png' />`)
    this.setState({
      html: newHTML
    })
  }

  handleChange(evt) {
    this.setState({ html: evt.target.value })
  }

  onFileChoose(e) {
    if (e.target.files) {
      let files = this.state.files

      for (let file in e.target.files) {
        if (e.target.files.hasOwnProperty(file)) {
          files.push(e.target.files[file])
        }
      }

      this.setState({
        files: files
      })
    }
  }

  _handleSubmit(e) {
    e.preventDefault()
  }

  _handleImageChange(e) {
    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onloadend = () => {
      if (file) {
        let files = this.state.files
        files.push(file)

        this.setState({
          files: files
        })
      }
    }
    reader.readAsDataURL(file)
  }

  showPicker() {
    this.setState({
      showEmojis: !this.state.showEmojis
    })
  }

  componentDidUpdate() {
    let promises = []
    if (this.props.selectedConversation) {
      scroll.scrollTo(99999, {
        containerId: 'message-block'
      })

      this.props.selectedConversation.messages.forEach((message, index) => {
        if (message.status === 'Unread' && message.sender.id !== this.props.user.id) {
          promises.push(
            this.props.updateMessage({
              variables: {
                id: message.id,
                status: 'Read'
              }
            })
          )
        }
      })

      if (promises.length) {
        Promise.all(promises)
      }
    }
  }

  render() {
    const { user, sendMessage, t, selectedConversation, style } = this.props

    let participants = []
    let fileNames = null

    if (selectedConversation) {
      participants = selectedConversation.users
        .filter(participant => {
          return participant.id !== user.id
        })
        .map(participant => {
          return participant.userProfile.firstName + ' ' + participant.userProfile.lastName
        })
      let { files } = this.state

      if (files && files.length) {
        fileNames = files.map((file, index) => (
          <div key={index}>
            <a href="">{file.name}</a>
          </div>
        ))
      }
      if ('ontouchstart' in document.documentElement) {
        document.body.style.cursor = 'pointer'
      }
    }

    return (
      <div style={style}>
        <div className="conversation-box" onClick={this.handleClickOutside}>
          <div className="interlocutor-details">
            <button className="back-button" onClick={this.props.showConversationList}>
              <img src="/img/arrow2.svg" />
            </button>

            <div className="avatar-wrapper">
              <img className="interlocutor-avatar" src="/img/user.svg" />
            </div>
            <div className="text">
              <div className="user">{participants}</div>
              <div className="user-message">{t('trip_details')}</div>
            </div>
          </div>
          <div className="message-box__header conversation__header">
            <button className="option" id="about-me">
              <img src="/img/user-small1.svg" />
              {t('about_me')}
            </button>
            <button className="option" id="messages" onClick={this.props.showConversationList}>
              <img src="/img/msg.svg" />
              {t('messages')}
            </button>
          </div>
          <div className="conversation-wrapper message_wrapper">
            <div className="message-section" id="message-block">
              {selectedConversation
                ? selectedConversation.messages.map((message, index) => (
                    <div
                      className={message.sender.id === user.id ? 'message-wrapper my-message' : 'message-wrapper interlocutor-message'}
                      key={index}
                    >
                      <div className={message.text ? 'message' : 'hidden'}>{converter.convert(message.text)}</div>

                      <div>
                        {message.files
                          ? message.files.map(
                              (file, index) =>
                                file.contentType.indexOf('image') !== -1 ? (
                                  <div className="imgPreview" key={index}>
                                    <img className="message-img" src={file.url} />
                                  </div>
                                ) : (
                                  <div className="message-wrapper__file" key={index}>
                                    <a href={file.url} className="file-link" download>
                                      <span>
                                        <i className="glyphicon glyphicon-file" />
                                      </span>
                                      {file.name}
                                    </a>
                                  </div>
                                )
                            )
                          : ''}
                      </div>
                    </div>
                  ))
                : []}
            </div>
            <div className="textarea-wrapper">
              <ContentEditable id="your-message" html={this.state.html} disabled={false} onChange={e => this.handleChange(e)} />

              <div className="icons">
                <div className="upload" onClick={() => this.showPicker()}>
                  <i className="fa fa-smile-o" />
                </div>
                <div className="upload image-upload">
                  <i className="fa fa-image" />
                  <input className="fileInput" type="file" accept="image/*" onChange={e => this._handleImageChange(e)} />
                </div>
                <div className="upload file-upload">
                  <i className="fa fa-paperclip" />
                  <input type="file" id="file-upload" multiple onChange={e => this.onFileChoose(e)} />
                </div>
              </div>
            </div>
            {fileNames}

            <button
              className="send-message-button"
              disabled={!this.state.html && !this.state.files.length}
              onClick={() => sendMessage(this.state)}
            >
              {t('send_button')}
            </button>
          </div>
        </div>
        <EmojiPicker className={this.state.showEmojis ? 'emoji-picker' : 'hidden'} onChange={emoji => this.logEmoji(emoji)} />
      </div>
    )
  }
}

const enhance = compose(
  translate('messenger'),
  graphql(UPDATE_MESSAGE, {
    name: 'updateMessage'
  }),
  enhanceWithClickOutside
)

export default enhance(Conversation)



// WEBPACK FOOTER //
// src/components/Chat/Conversation.jsx